//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

import { FieldError, UseFormSetError } from 'react-hook-form';

import { EditableBVSamplingProduct } from '@campaigns/types/sampling/SamplingProductTypes';
import { getVariationFormatErrors } from '@campaigns/utils/sampling/reviewProductCardValidationUtils';

const isFieldError = (value: object): value is FieldError =>
  typeof (value as Partial<FieldError>).type === 'string';

/**
 * Whether react-hook-form errors include a malformed value, i.e. any error
 * other than a missing required value. Walks nested and field array errors.
 */
export const hasMalformedFieldErrors = (errors: unknown): boolean => {
  if (!errors || typeof errors !== 'object') {
    return false;
  }

  if (isFieldError(errors)) {
    return errors.type !== 'required';
  }

  return Object.values(errors).some(hasMalformedFieldErrors);
};

// Image rules may be unregistered while their picker is closed.
export const validateDrawerVariations = (
  variations: EditableBVSamplingProduct['variations'],
  setError: UseFormSetError<EditableBVSamplingProduct>,
  isBVShipped: boolean,
): boolean => {
  let isValid = true;
  variations.forEach((variation, index) => {
    const errors = getVariationFormatErrors(variation, isBVShipped);
    const fields = [
      'fairMarketValue',
      'imgUrl',
      'logisticsRef',
      'quantity',
    ] as const;
    fields.forEach((field) => {
      const message = errors[field];
      if (message) {
        isValid = false;
        setError(`variations.${index}.${field}`, {
          message,
          type: 'validate',
        });
      }
    });
  });
  return isValid;
};
